// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YcGr","buttons":"styles_buttons__2mJUx"};